<template>
  <div class="developer">
    <div class="part-1">
      <div class="main">
        <p class="title">{{ $t('team.head') }}</p>
        <p class="desc">{{ $t('team.desc') }}</p>
      </div>
    </div>

    <div class="part-4">
      <div class="main">
        <p class="tit">{{ $t('team.part3.head') }}</p>

        <div class="items">
          <div class="item" >
            <img src="../assets/images/team/25.png" alt />
            <p class="name">{{ $t('team.part2.title5') }}</p>
          </div>
          
          <div class="item"  >
            <img src="../assets/images/team/32.png" alt />
            <p class="name">{{ $t('team.part3.title2') }}</p>
          </div>
          
          <div class="item"  >
            <img src="../assets/images/team/11.png" alt />
            <p class="name">{{ $t('team.part1.title1') }}</p>
          </div>
        
        </div>
      </div>
    </div>

    <div class="part-4">
      <div class="main">
        <p class="tit">{{ $t('team.part2.head') }}</p>
          <div  class="items" >
            <div class="item swiper-slide" >
              <img src="../assets/images/team/21.png" alt />
              <p class="name">{{ $t('team.part2.title1') }}</p>
            </div>
            

            <div class="item swiper-slide"  >
              <img src="../assets/images/team/22.png" alt />
              <p class="name">{{ $t('team.part2.title2') }}</p>
            </div>
          

            <div class="item swiper-slide"  >
              <img src="../assets/images/team/23.png" alt />
              <p class="name">{{ $t('team.part2.title3') }}</p>
            </div>
            

            <div class="item swiper-slide"  >
              <img src="../assets/images/team/24.png" alt />
              <p class="name">{{ $t('team.part2.title4') }}</p>
            </div>
            

           <!-- <div class="item swiper-slide" v-show="p3item5" @mouseover="p3item5=false">
              <img src="../assets/images/team/25.png" alt />
              <p class="name">{{ $t('team.part2.title5') }}</p>
            </div>
            <div class="item swiper-slide mouseover" v-show="!p3item5" @mouseout="p3item5=true">
              <p class="personname">{{ $t('team.part2.title5') }}</p>
              <p class="jieshao">{{ $t('team.part2.description5') }}</p>
            </div>-->
          </div>
      </div>
    </div>


  </div>
</template>

<script>
import { CarouselItem, Carousel } from "iview";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "team",
  components: {},
  data() {
    return {
     
    };
  },
  mounted() {
  
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.developer {
  .part-1 {
    height: 599px;
    background-image: url("../assets/images/team-bg.png");
    @media screen and (max-width: 1400) {
      background-image: url("../assets/images/team-bg-sm.png");
    }
    background-repeat: no-repeat;
    background-size: auto 100%;
    overflow: hidden;
    .main {
      .title {
        font-size: 66px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-top: 260px;
      }
      .desc {
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .part-2 {
    background-color: #fff;
    .main {
      overflow: hidden;
      position: relative;
    }
    .cont {
      background-color: #fff;
      .tit {
        text-align: center;
        font-size: 30px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-top: 80px;
      }
      .row2 {
        display: flex;
        justify-content: space-around;
        height: 400px;
        margin-top: 60px;
        margin-bottom: 5px;
        .item {
          width: 280px;
          text-align: center;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          img {
            height: 208px;
            width: 208px;
            margin-top: 50px;
          }
          .name {
            font-size: 24px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-top: 45px;
          }
          .attr {
            margin-top: 10px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(85, 85, 85, 1);
          }
          &.mouseover {
            background-color: #5091fd;
            padding-left: 16px;
            padding-right: 16px;
            overflow-y: auto;
            position: relative;
            .personname {
              margin-top: 20px;
              font-size: 24px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }
            .jieshao {
              //text-align: justify;
              text-align: left;
              margin-top: 20px;
              margin-bottom: 20px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
    }
  }
 
  .part-4 {
    background-color: #fff;
    .main {
      overflow: hidden;
      height: 100%;
    }
    .tit {
      .part-tit();
      margin-top: 80px;
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .items {
      margin-top: 60px;
      margin-bottom: 100px;
      display: flex;
      justify-content: space-around;
      .item {
        width: 255px;
        height: 400px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        margin: 0 10px;
        text-align: center;
        img {
          width: 208px;
          height: 208px;
          margin-top: 50px;
        }
        .name {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 45px;
        }
        .attr {
          margin-top: 10px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
        }
        &.mouseover {
          background-color: #5091fd;
          padding-left: 16px;
          padding-right: 16px;
          overflow-y: auto;
          position: relative;
          .personname {
            margin-top: 20px;
            font-size: 24px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .jieshao {
            //text-align: justify;
            text-align: left;
            margin-top: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
}
/deep/.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("../assets/images/team/jiantou-you.png");
  background-size: 44px 44px;
  background-repeat: no-repeat;
}
/deep/.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("../assets/images/team/jiantou-zuo.png");
  background-size: 44px 44px;
  background-repeat: no-repeat;
}
/deep/.swiper-button-prev,
.swiper-button-next {
  width: 44px;
}
/deep/.ivu-carousel {
  height: 100%;
}
/deep/.ivu-carousel-dots-inside {
  bottom: 100px;
}
/deep/.ivu-carousel-arrow {
  top: 38%;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background-color: #eaeaea;
}
</style>
